import { gql } from '@apollo/client';

export const CONFIG_FILE = gql`
  query configFile($id: ID!) {
    configFile(id: $id) {
      id
      name
      content
      createdDate
      modifiedDate
      readOnly
    }
  }
`;

export const FORMAT_CONFIG_FILE = gql`
  mutation formatConfigFile($id: ID!, $content: String!) {
    formatConfigFile(id: $id, content: $content) 
  }
`;

export const ADD_CONFIG_FILE = gql`
  mutation addConfigFile($name: String!, $content: String) {
    addConfigFile(name: $name, content: $content) {
      id
      name
      content
      createdDate
      modifiedDate
    }
  }
`;

export const DELETE_CONFIG_FILE = gql`
  mutation deleteConfigurationFile($id: ID!) {
    deleteConfigFile(id: $id) {
      id
      name
      content
      createdDate
      modifiedDate
    }
  }
`;
